/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    checked: {
      description: 'Corresponds to a selected state for a checkbox or radio',
      type: 'state',
      values: [ true ]
    },
    error: { type: 'state', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'lg', 'xl' ] },
      tokens: {
        fontSize: 24,
        lineHeight: 1.33333333333,
        paddingBottom: 24,
        paddingLeft: 16,
        paddingRight: 24,
        paddingTop: 16
      }
    },
    {
      if: { hover: true },
      tokens: {
        borderColor: '#676e73',
        outerBorderColor: '#e3e6e8',
        radioOuterBorderColor: '#e3e6e8',
        radioOuterBorderWidth: 2
      }
    },
    {
      if: { focus: true },
      tokens: {
        outerBorderColor: '#676e73',
        outerBorderGap: 2,
        radioInputBorderColor: '#7c53a5',
        radioInputBorderWidth: 3
      }
    },
    {
      description: 'Pressed state matches hover state plus light grey background',
      if: { pressed: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#676e73',
        outerBorderColor: '#e3e6e8',
        outerBorderGap: 0,
        radioInputBorderColor: '#676e73',
        radioInputBorderWidth: 1,
        radioOuterBorderColor: '#e3e6e8',
        radioOuterBorderWidth: 3
      }
    },
    { if: { checked: true }, tokens: { borderColor: '#7c53a5' } },
    {
      if: { checked: true, hover: true },
      tokens: { borderColor: '#4b286d' }
    },
    {
      if: { error: true },
      tokens: {
        borderColor: '#e12339',
        color: '#e12339',
        radioInputBorderColor: '#e12339'
      }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#676e73',
        radioCheckedBackgroundColor: '#676e73',
        radioInputBackgroundColor: '#b2b9bf',
        radioInputBorderColor: 'transparent',
        radioInputSize: 12,
        radioOuterBorderColor: '#b2b9bf',
        radioOuterBorderGap: 2,
        radioOuterBorderWidth: 1
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#b2b9bf',
    borderRadius: 6,
    borderWidth: 1,
    color: '#2c2e30',
    contentAlignItems: 'stretch',
    contentFlexGrow: 0,
    contentFlexShrink: 1,
    contentJustifyContent: 'flex-start',
    contentSpace: 2,
    flex: 1,
    fontName: 'HNforTELUSSA',
    fontSize: 20,
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: 1.4,
    minWidth: 264,
    outerBorderColor: 'transparent',
    outerBorderGap: 0,
    outerBorderWidth: 2,
    paddingBottom: 16,
    paddingLeft: 10,
    paddingRight: 16,
    paddingTop: 16,
    radioCheckedBackgroundColor: '#7c53a5',
    radioCheckedSize: 12,
    radioInputBackgroundColor: '#ffffff',
    radioInputBorderColor: '#676e73',
    radioInputBorderWidth: 1,
    radioInputOutlineColor: 'rgba(0, 0, 0, 0)',
    radioInputOutlineWidth: 0,
    radioInputSize: 20,
    radioOuterBorderColor: 'transparent',
    radioOuterBorderGap: 0,
    radioOuterBorderWidth: 0,
    radioSpace: 2,
    shadow: null,
    textTransform: 'none'
  }
}
export default theme
